module.exports = __webpack_public_path__ + "static/man-l-2770d3a35a2c7131356d847cff25a9d9.jpg";